@if (loading) {
  <section id="loader-container">
    <ng-casto-loader></ng-casto-loader>
  </section>
}

<div class="preview-container" id="preview-container">
  <div class="layers">
    <div style="width: 1px; height: 100%"></div>
    @if (items.length > 0) {
      @for (item of items; track item.id) {
        <ng-fence-preview-element [item]="item" (isLoaded)="onLoaded(item.position)"></ng-fence-preview-element>
      }
    }
  </div>
  <h5 class="panel-count">
    {{ configuration.panelCount?.completeCount }} {{ 'fence.preview.panels' | translate }}
  </h5>
</div>
